module.exports = __webpack_public_path__ + "img/potentialcustomer_icon_grey.53296258.svg";